import React from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Content from '../../Components/Content/Content';


const MainPage: React.FC = () => (<>
  <Header />
  <Content />
  <Footer />
</>
);

export default MainPage;
